// getCookieValue: https://stackoverflow.com/a/25490531/4042057
export const getCookieValue = a => {
  var b = document.cookie.match(`(^|;)\\s*${a}\\s*=\\s*([^;]+)`)
  return b ? b.pop() : ''
}
